export const HOBBLI_SUPPORT_ID =
  process.env.REACT_APP_HOBBLI_SUPPORT_ID ||
  "02a5780e-5171-4577-b4b2-d8780937f223";

export const ADMIN_PAGE_SIZE = 40;

export function formatAdminDate(value) {
  if (!value) return "—";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString();
}

export function formatCompactNumber(value) {
  const number = Number(value || 0);
  return Number.isFinite(number) ? number.toLocaleString() : "0";
}

export function getSupabaseErrorMessage(error, fallback = "Something went wrong.") {
  if (!error) return fallback;
  return error.message || error.details || error.hint || fallback;
}
